import type { ActionProposal, NavigationCommand } from "./types";

/**
 * Parse action proposals from Grafton's markdown response.
 * Format: ACTION: Titre | Description | priorité
 */
export function parseActionsFromResponse(content: string): ActionProposal[] {
  const actions: ActionProposal[] = [];
  const regex = /ACTION:\s*(.+?)\s*\|\s*(.+?)\s*\|\s*(haute|moyenne|basse)/gi;
  let match;

  while ((match = regex.exec(content)) !== null) {
    actions.push({
      id: crypto.randomUUID(),
      title: match[1].trim(),
      description: match[2].trim(),
      priority: match[3].toLowerCase() as ActionProposal["priority"],
      validated: false,
    });
  }

  return actions;
}

/** Route mapping for navigation commands */
const ROUTE_MAP: Record<string, { route: string; label: string }> = {
  "dashboard": { route: "/dashboard", label: "Tableau de bord" },
  "tableau de bord": { route: "/dashboard", label: "Tableau de bord" },
  "tresorerie": { route: "/tresorerie", label: "Trésorerie" },
  "trésorerie": { route: "/tresorerie", label: "Trésorerie" },
  "comptabilite": { route: "/comptabilite", label: "Comptabilité" },
  "comptabilité": { route: "/comptabilite", label: "Comptabilité" },
  "ventes": { route: "/ventes", label: "Ventes" },
  "marketing": { route: "/marketing", label: "Marketing" },
  "emails": { route: "/emails", label: "E-mails" },
  "appels": { route: "/appels", label: "Appels" },
  "agenda": { route: "/agenda", label: "Agenda" },
  "contacts": { route: "/communication", label: "Communication" },
  "communication": { route: "/communication", label: "Communication" },
  "reseaux sociaux": { route: "/social", label: "Réseaux sociaux" },
  "réseaux sociaux": { route: "/social", label: "Réseaux sociaux" },
  "tunnel de vente": { route: "/tunnel-vente", label: "Tunnel de vente" },
  "nanocorp": { route: "/nanocorp", label: "NanoCorp" },
  "briefing": { route: "/briefing", label: "Briefing" },
  "business plan": { route: "/business-plan", label: "Business Plan" },
  "financement": { route: "/financement", label: "Financement" },
  "rh": { route: "/rh", label: "RH & Recrutement" },
  "recrutement": { route: "/rh", label: "RH & Recrutement" },
  "parametres": { route: "/parametres", label: "Paramètres" },
  "paramètres": { route: "/parametres", label: "Paramètres" },
  "offres": { route: "/offres", label: "Offres" },
  "plan d'action": { route: "/my-action-plan", label: "Plan d'action" },
  "creation entreprise": { route: "/creation-entreprise", label: "Création d'entreprise" },
  "création entreprise": { route: "/creation-entreprise", label: "Création d'entreprise" },
  "securite": { route: "/securite", label: "Sécurité" },
  "sécurité": { route: "/securite", label: "Sécurité" },
  "site web": { route: "/my-website", label: "Mon site web" },
  "site internet": { route: "/my-website", label: "Mon site web" },
  "mon site": { route: "/my-website", label: "Mon site web" },
  "créer un site": { route: "/my-website", label: "Mon site web" },
  "creer un site": { route: "/my-website", label: "Mon site web" },
  "templates": { route: "/my-website", label: "Mon site web" },
  "laboratoire": { route: "/laboratoire", label: "Le laboratoire" },
  "espace physique": { route: "/laboratoire/espace-physique", label: "L'espace physique Grafton IA" },
  "pilotage": { route: "/pilotage", label: "Pilotage de l'objectif" },
  "pilotage de l'objectif": { route: "/pilotage", label: "Pilotage de l'objectif" },
  "mon plan": { route: "/mon-plan", label: "Mon plan" },
  "savoir-faire": { route: "/savoir-faire", label: "Savoir-faire" },
  "savoir faire": { route: "/savoir-faire", label: "Savoir-faire" },
  "atelier": { route: "/atelier", label: "Atelier de site" },
  "competences": { route: "/competences", label: "Compétences" },
  "compétences": { route: "/competences", label: "Compétences" },
  "adn grafton": { route: "/adn-grafton", label: "ADN Grafton" },
  "marches publics": { route: "/marches-publics", label: "Marchés publics" },
  "marchés publics": { route: "/marches-publics", label: "Marchés publics" },
  "communication": { route: "/communication", label: "Communication" },
};

/**
 * Parse navigation commands from Grafton's response.
 * Format: NAVIGATE: route_key
 */
export function parseNavigationFromResponse(content: string): NavigationCommand | null {
  const regex = /NAVIGATE:\s*(.+)/i;
  const match = regex.exec(content);
  if (!match) return null;

  const key = match[1].trim().toLowerCase();
  return ROUTE_MAP[key] ?? null;
}

/**
 * Remove ACTION: and NAVIGATE: lines from content for clean display
 */
export function cleanContentFromActions(content: string): string {
  return content
    .replace(/ACTION:\s*.+?\|.+?\|\s*(haute|moyenne|basse)\s*/gi, "")
    .replace(/NAVIGATE:\s*.+/gi, "")
    .replace(/\n{3,}/g, "\n\n")
    .trim();
}
